export default "__VITE_ASSET__BTS$vWLw__"